import PropTypes from "prop-types";
import React from "react";

import { AppFooter, SuppressForNative } from "@swa-ui/application";
import { DotcomFooter } from "@swa-ui/dotcom";

import { useNavigationType } from "../../hooks/useNavigationType";

/**
 * LandingPageFooter will render the footer for static html pages.
 */

export const LandingPageFooter = (props) => {
  const { className } = props;
  const navigationType = useNavigationType();

  return (
    <SuppressForNative>
      <div className={className}>
        <AppFooter />
        <DotcomFooter type={navigationType} />
      </div>
    </SuppressForNative>
  );
};

LandingPageFooter.propTypes = {
  /**
   * Additional classes for positioning the component.
   */
  className: PropTypes.string,
};
